import React from 'react';

const KeySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5 21.3l-9.6-9.6c2.1-2.2 2.1-5.8-.1-8C10.7 2.6 9.2 2 7.7 2s-2.9.6-4 1.7c-2.2 2.2-2.2 5.9 0 8.1 1.1 1.1 2.6 1.7 4.1 1.7 1.2 0 2.4-.4 3.4-1.1l5.1 5.1-1.8 1.8.7.7 1.8-1.8 1.4 1.4-1.8 1.8.7.7 1.8-1.8 1.8 1.8.6-.8zM4.4 11.1c-1.8-1.8-1.8-4.9 0-6.7C5.3 3.5 6.5 3 7.7 3c1.3 0 2.5.5 3.3 1.4 1.8 1.8 1.8 4.9 0 6.7-.8.9-2 1.4-3.3 1.4-1.2 0-2.4-.5-3.3-1.4z"
        />
    </svg>
);

KeySvg.displayName = 'KeySvg';
export default KeySvg;
